import { render, staticRenderFns } from "./Helpdesk.vue?vue&type=template&id=ff4eed32&scoped=true"
import script from "./Helpdesk.vue?vue&type=script&lang=js"
export * from "./Helpdesk.vue?vue&type=script&lang=js"
import style0 from "./Helpdesk.vue?vue&type=style&index=0&id=ff4eed32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4eed32",
  null
  
)

export default component.exports